// @flow

import { Paper, useMediaQuery } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import TrashIcon from "../../../assets/images/icons/buttons/trashIcon";
import { EXHIBITION } from "../../../locales/components/namespaces";
import FileUpload from "../../form/fileUpload/fileUpload";
import ContentLoader from "../contentLoader/contentLoader";

type Props = {

};

const ImageOrPdfUploadWithPreview = (props: Props) => {
	const { t } = useTranslation(EXHIBITION)
	const {
		loading,
		loadingDelete,
		deleteFile,
		uploadFile,
		file,
		disabled = false,
		allowedFiles = {
			'image/jpeg': [],
			'image/png': [],
			'application/pdf': ['.pdf'],
		}
	} = props
	const theme = useTheme()
	const isDownMd = useMediaQuery(theme.breakpoints.down('md'))
	return (
		<Paper
			sx={{
				px: 2,
				p: 4,
				border: '1px solid',
				borderColor: theme.palette.primary[200],
				borderRadius: '12px'
			}}
			variant={"outlined"}>
			<Grid container spacing={1.5}>
				<Grid size={12}>
					<Stack
						direction="row"
						
						sx={{ justifyContent: 'end' }}
					>
						<Button
							loading={loadingDelete}
							color={'error'}
							loadingPosition="start"
							variant={"outlined"}
							size={"small"}
							startIcon={<TrashIcon/>}
							onClick={deleteFile}
							sx={{ width: isDownMd ? '100%' : 'auto' }}
							disabled={disabled || !file}
						>
							{t('Delete')}
						</Button>
					</Stack>
				</Grid>
				<Grid size={12}>
					<FileUpload
						accept={allowedFiles}
						multiple={false}
						onFilesUpload={(files) => {
							if (files && files.length > 0) uploadFile(files[0])
						}}
						disabled={disabled}
					/>
				</Grid>
				<Grid size={12}>
					{!loading && file && (
						<>
							{file.type === 'pdf' ? (
								<iframe
									src={file.url}
									title="PDF Preview"
									style={{ width: '100%', height: '600px', border: 'none' }}
								/>
							) : (
								<img src={`data:image/jpeg;base64,${file.url}`} alt="ad logo"
								     style={{ maxWidth: '100%', maxHeight: '600px' }}/>
							)}
						</>
					)}
				</Grid>
				<Grid size={12}>
					<ContentLoader loading={loading} useCircularLoader/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default ImageOrPdfUploadWithPreview